export default [
  {
    path: "/not-found",
    name: "404",
    meta: { title: "Stran ne obstaja" },
    component: () => import(/* webpackChunkName: "404 View" */ "@/Modules/404/Views")
  }
]
